import { styled } from 'styled-components';
import { Theme } from '../../themes';

export const Root = styled.div<{ $centerInContainer: boolean }>`
    flex: 1;
    align-items: center;
    display: flex;
    justify-content: ${({ $centerInContainer }) => ($centerInContainer ? 'center' : 'flex-start')};
`;

export const ImageWrapper = styled.div<
    {
        src?: string;
        $mixBlendMode: string;
        $fitToContainer: boolean;
        $centerInContainer: boolean;
    },
    Theme
>`
    align-items: center;
    justify-content: center;
    background-image: ${({ src }) => (src ? `url("${src}")` : 'none')};
    background-repeat: no-repeat;
    mix-blend-mode: ${({ $mixBlendMode }) => $mixBlendMode};
    background-position-y: center;
    ${({ $fitToContainer }) => $fitToContainer && 'background-size: contain;'}
    ${({ $fitToContainer }) => $fitToContainer && 'flex: 1;'}
`;

export const Image = styled.img`
    opacity: 0;
    max-width: 100%;
`;
